import React, { useState, useEffect } from 'react';

const PageThumbnail = ({
  page,
  pageIndex,
  isSelected,
  isDragging,
  thumbnailUrl,
  onSelect,
  onDragStart,
  onDragEnd,
  readOnly = false,
}) => {
  const [imageLoaded, setImageLoaded] = useState(false);

  useEffect(() => {
    setImageLoaded(false);
  }, [thumbnailUrl]);

  const handleClick = (e) => {
    e.stopPropagation();
    onSelect(pageIndex);
  };

  const handleDragStart = (e) => {
    e.dataTransfer.effectAllowed = 'move';
    e.dataTransfer.setData('text/plain', pageIndex.toString());
    onDragStart(pageIndex);
  };

  const handleDragEnd = () => {
    onDragEnd();
  };

  // Read-only (split review): pages are in the order the stored PDF has them
  // and cannot be moved, so they are not draggable at all.
  return (
    <div
      className={`ds-page-thumbnail-wrapper ${isSelected ? 'ds-page-thumbnail-wrapper--selected' : ''}`}
      onClick={handleClick}
    >
      <div
        className={`ds-page-thumbnail ${isSelected ? 'ds-page-thumbnail--selected' : ''} ${
          page.deleted ? 'ds-page-thumbnail--deleted' : ''
        } ${isDragging ? 'ds-page-thumbnail--dragging' : ''} ${readOnly ? 'ds-page-thumbnail--readonly' : ''}`}
        draggable={!readOnly && !page.deleted}
        onDragStart={readOnly ? undefined : handleDragStart}
        onDragEnd={readOnly ? undefined : handleDragEnd}
      >
      <div className="ds-page-thumbnail-image-wrapper">
        {!imageLoaded && (
          <div className="ds-page-thumbnail-loading">
            <div className="ds-spinner-small" />
          </div>
        )}
        {thumbnailUrl && (
          <img
            src={thumbnailUrl}
            alt={`Page ${pageIndex + 1}`}
            className="ds-page-thumbnail-image"
            onLoad={() => setImageLoaded(true)}
            style={{
              display: imageLoaded ? 'block' : 'none',
              transform: `rotate(${page.rotation}deg)`,
            }}
          />
        )}
      </div>

      {page.deleted && (
        <div className="ds-page-thumbnail-deleted-overlay">
          <div className="ds-page-thumbnail-deleted-icon">🗑</div>
        </div>
      )}

      {page.annotation && (
        <div className="ds-page-thumbnail-annotation">
          {page.annotation}
        </div>
      )}
      </div>
      <div className="ds-page-thumbnail-number">
        {pageIndex + 1}
      </div>
    </div>
  );
};

export default PageThumbnail;
